import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setRecommendedActions } from "@oldDashboard/legacyActions/dashboardClient";

interface useRecommendedActionsProps { affiliateSelected: String, launchSelected: String, timePeriodSelected: String, sort: String, searching: boolean }

const useRecommendedActions = (props: useRecommendedActionsProps) => {
    const { affiliateSelected, launchSelected, timePeriodSelected, searching, sort } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchUseRecommended(sort);
    }, [searching, launchSelected]);


    const fetchUseRecommended = async(sort: String) => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getRecommendedActions(affiliateSelected, launchSelected, timePeriodSelected, sort);
            if(response){
                setRecommendedActions(response);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { isLoading, fetchUseRecommended }
}

export default useRecommendedActions;